import { CSSProperties, ReactNode } from "react";
import { SelectValue, SuperSelectProps } from "../SuperSelect/interface";
import { TextAreaRowProps } from "../TextAreaRow/interface";
import { RadioGroupProps } from "../RadioGroup";

export interface GroupSearchProps {
  /** 样式 */
  style?: CSSProperties,
  /** 类名 */
  className?: string;
  /** 组合值 */
  value?: GroupSearchValue;
  /** 默认组合值 */
  defaultValue?: GroupSearchValue;
  /** 是否禁用 */
  disabled?: boolean;
  /** 前置搜索字段类型下拉配置 */
  beforeSuperSelectProps?: SuperSelectProps;
  /** 匹配规则按钮组配置 */
  matchRuleRadioGroupProps?: RuleRadioGroupProps;
  /** 末尾匹配值多行输入框配置 */
  textAreaRowProps?: TextAreaRowProps;
  /** 自定义 searchType、matchCondition、matchValue 的字段名称 */
  fieldNames?: GroupSearchFieldNamesType;
  /** 需要转换成大写的字段 */
  upperCaseSearchType?: string[];
  /** value改变回调 */
  onChange?: (value?: GroupSearchValue) => void;
};
/** 匹配规则按钮组配置 */
export interface RuleRadioGroupProps extends RadioGroupProps {
  /** 标题 */
  title?: ReactNode;
}

export interface GroupSearchValue {
  /** 前置搜索字段 */
  searchType?: SelectValue;
  /** 中间匹配规则字段 */
  matchCondition?: SelectValue;
  /** 匹配值 */
  matchValue?: string[];
  /** 其他 */
  [prop: string]: any;
};

export interface GroupSearchFieldNames {
  /** 搜索字段 */
  searchType: string;
  /** 匹配规则 */
  matchCondition: string;
  /** 值 */
  matchValue: string;
}

export type GroupSearchFieldNamesType = Partial<GroupSearchFieldNames>;
/** 默认字段名称 */
export const DEFAULT_FIELD_NAMES: GroupSearchFieldNames = {
  searchType: 'searchType',
  matchCondition: 'matchCondition',
  matchValue: 'matchValue',
};
